import { render, staticRenderFns } from "./reisen-saisonpreise-view.vue?vue&type=template&id=650ee020&scoped=true"
import script from "./reisen-saisonpreise-view.vue?vue&type=script&lang=js"
export * from "./reisen-saisonpreise-view.vue?vue&type=script&lang=js"
import style0 from "./reisen-saisonpreise-view.vue?vue&type=style&index=0&id=650ee020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ee020",
  null
  
)

export default component.exports